// src/components/Auth/SupplierLogin.jsx
import React, { useState } from 'react';
import { Building2, Lock, Mail, AlertTriangle, ArrowRight, Loader2 } from 'lucide-react';
import './SupplierLogin.css';

const API_BASE_URL = "https://api.lbnhyderabad.com" || 'https://api.lbnhyderabad.com';

export default function SupplierLogin({ onLoginSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg('');
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE_URL}/api/supplier/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await res.json();

      if (!res.ok || !data.success) {
        throw new Error(data.message || 'Login failed.');
      }

      onLoginSuccess(data.supplier);
    } catch (err) {
      setErrorMsg(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="supplier-login-root">
      <div className="supplier-login-card">
        <div className="supplier-login-banner">
          <div className="supplier-login-crest">
            <Building2 size={24} />
          </div>
          <h2>Supplier Portal Access</h2>
          <p>Commercial Network Partner Console</p>
        </div>

        <div className="supplier-login-body">
          {errorMsg && (
            <div style={{
              background: '#fef2f2',
              border: '1.2px solid #fecaca',
              color: '#991b1b',
              padding: '10px 12px',
              borderRadius: '8px',
              fontSize: '0.78rem',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              marginBottom: '16px'
            }}>
              <AlertTriangle size={16} />
              <span>{errorMsg}</span>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '14px' }}>
              <label style={{ display: 'block', fontSize: '0.72rem', fontWeight: 800, color: '#064e3b', marginBottom: '6px', textTransform: 'uppercase' }}>
                Corporate Email Address
              </label>
              <input
                type="email"
                className="supplier-input-field"
                placeholder="registered@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', fontSize: '0.72rem', fontWeight: 800, color: '#064e3b', marginBottom: '6px', textTransform: 'uppercase' }}>
                Portal Access Password
              </label>
              <input
                type="password"
                className="supplier-input-field"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="btn-supplier-login" disabled={loading}>
              {loading ? (
                <>
                  <Loader2 size={16} className="spin-loader" />
                  <span>Authenticating...</span>
                </>
              ) : (
                <>
                  <span>Sign In To Console</span>
                  <ArrowRight size={16} />
                </>
              )}
            </button>
          </form>

          <div style={{ textAlign: 'center', marginTop: '18px', fontSize: '0.75rem', color: '#64748b' }}>
            New vendor enterprise? <a href="/supplier-onboard" style={{ color: '#059669', fontWeight: 700, textDecoration: 'none' }}>Register Here</a>
          </div>
        </div>
      </div>
    </div>
  );
}